<template>

    <div>
        <v-modal
            :open="open"
            class="c-modal_event_show">
            <div v-if="!isFetching && this.open">
                <header class="c-modal_event_show__heading">
                    <h2 class="c-modal_event_show__heading-title" v-if="event.type !== 'block'">
                        <span>Wizyta dla:</span>
                        <router-link
                            :to="{ name: 'PatientShow', params: { id: event.patient_id } }">
                            {{ patientName }}
                        </router-link>
                    </h2>
                    <h2 class="c-modal_event_show__heading-title" v-if="event.type === 'block'">
                        <span>Blokada slotu czasowego</span>
                    </h2>
                    <div class="c-modal_event_show__heading-actions" v-if="!event.visit_id">
                        <v-btn
                            title="Edytuj wydarzenie"
                            type="icon"
                            icon="edit"
                            @click="editEvent">
                        </v-btn>

                        <v-btn
                            title="Usuń wydarzenie"
                            type="icon"
                            icon="delete"
                            @click="$refs.eventRemoveModal.$emit('open', event.id, !!event.portal_identifier)">
                        </v-btn>
                    </div>
                </header>
                <table class="c-modal_event_show__list">
                    <tbody>
                    <tr class="c-modal_event_show__item">
                        <td class="c-modal_event_show__item-label">Data:</td>
                        <td class="c-modal_event_show__item-value">{{ eventDate }}</td>
                    </tr>
                    <tr class="c-modal_event_show__item">
                        <td class="c-modal_event_show__item-label">Godzina:</td>
                        <td class="c-modal_event_show__item-value">{{ eventHours }}</td>
                    </tr>
                    <tr class="c-modal_event_show__item" v-if="event.type !== 'block'">
                        <td class="c-modal_event_show__item-label">Typ wizyty:</td>
                        <td class="c-modal_event_show__item-value">{{ eventType }}</td>
                    </tr>
                    <tr class="c-modal_event_show__item" v-if="event.type !== 'block'">
                        <td class="c-modal_event_show__item-label">Placówka:</td>
                        <td class="c-modal_event_show__item-value" v-html="eventAddress"></td>
                    </tr>
                    <tr class="c-modal_event_show__item" v-if="event.type !== 'block' && event.visit_id">
                        <td class="c-modal_event_show__item-label">Status wizyty:</td>
                        <td class="c-modal_event_show__item-value">
                            <span class="c-modal_event_show__status">{{ eventStatus }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="c-modal_event_show__list" v-if="event.type !== 'block'">
                    <tbody>
                    <tr class="c-modal_event_show__item">
                        <td class="c-modal_event_show__item-label">Pacjent:</td>
                        <td class="c-modal_event_show__item-value">
                            <router-link
                                class="c-modal_event_show__patient"
                                :to="{ name: 'PatientShow', params: { id: event.patient_id } }">
                                {{ patientName }}
                            </router-link>
                        </td>
                    </tr>
                    <tr class="c-modal_event_show__item">
                        <td class="c-modal_event_show__item-label">Numer telefonu:</td>
                        <td class="c-modal_event_show__item-value"><a :href="`tel: ${patientPhone}`">{{ patientPhone }}</a>
                        </td>
                    </tr>
                    <tr class="c-modal_event_show__item">
                        <td class="c-modal_event_show__item-label">Email:</td>
                        <td class="c-modal_event_show__item-value"><a :href="`mailto: ${patientEmail}`">{{
                                patientEmail
                            }}</a></td>
                    </tr>
                    </tbody>
                </table>
                <form-row align="between">
                    <div v-if="event.type !== 'block'">
                        <v-btn v-if="event.visit_id"
                               type="green"
                               :to="{ name: 'PatientVisitEdit', params: { id: event.patient_id, id1: event.visit_id } }">
                            {{ btnLabel }}
                        </v-btn>
                        <v-btn v-else
                               type="green"
                               :to="{ name: 'PatientShow', params: { id: event.patient_id } }">
                            Przejdź do pacjenta
                        </v-btn>
                    </div>

                    <div>
                        <v-btn
                            type="white"
                            @click="cancel">
                            Zamknij
                        </v-btn>
                    </div>

                </form-row>
            </div>
            <v-loader
                :loading="isFetching">
            </v-loader>
        </v-modal>
        <event-remove-modal ref="eventRemoveModal" @success="eventDeleted"></event-remove-modal>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import moment from 'moment'
import {FormRow, FormInline, FormInput, FormDate, FormSwitch, FormSelect} from 'Components/Form'
import VModal from 'Components/VModal'
import EventRemoveModal from 'Components/Event/EventRemoveModal'

import VLoader from 'Components/VLoader'
import VBtn from 'Components/VBtn'

export default {

    name: 'ModalEventShow',

    data() {
        return {
            open: false,
            isFetching: true,
            rawEvent: null
        }
    },

    computed: {
        ...mapGetters(['event']),
        btnLabel() {
            return (this.event.visit.status === 'completed') ? 'Edytuj wizytę' : 'Kontynuuj wizytę'
        },
        eventDate() {
            return moment(this.event.start).format('DD.MM.YYYY')
        },
        eventHours() {
            return moment(this.event.start).format('HH:mm') + ' - ' + moment(this.event.end).format('HH:mm')
        },
        eventType() {
            return (this.event.type === 'office') ? 'W gabinecie' : 'Domowa'
        },
        eventAddress() {
            if (this.event.office_id)
                return this.event.office.name || '—'
            else
                return this.patientAddress || '—'
        },
        eventStatus() {
            return (this.event.visit.status === 'completed') ? 'Zrealizowana' : 'W toku'
        },
        patientName() {
            let name = this.event.patient.first_name + ' ' + this.event.patient.last_name
            return name.trim()
        },
        patientPhone() {
            return this.event.patient.phone || '—'
        },
        patientEmail() {
            return this.event.patient.email || '—'
        },
        patientAddress() {
            if (this.event.patient.address_street === '' && this.event.patient.address_city === '')
                return '—'
            var address = ''
            address += this.event.patient.address_street || ''
            if (this.event.patient.address_street && this.event.patient.address_city)
                address += ', '
            address += this.event.patient.address_city || ''
            return address
        }

    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel')
        },
        eventDeleted() {
            this.cancel()
            this.$emit('event-deleted')
        },
        editEvent() {
            this.open = false;
            this.$nextTick(() => {
                this.$emit('edit', this.rawEvent);
            });
        }
    },

    mounted() {
        this.$on('open', (_event) => {
            this.rawEvent = Object.assign({}, _event)
            this.open = true
            this.isFetching = true

            this.$store.dispatch('EVENT_FETCH', {
                id: _event.id,
                query: {with: 'visit,office,patient'}
            }).then(() => {
                this.isFetching = false
            }).catch((error) => {
                this.$alert.error('Kalendarz', error.response.data.message)
                this.open = false
            })
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        FormRow,
        FormInline,
        FormInput,
        FormDate,
        FormSwitch,
        FormSelect,
        VModal,
        EventRemoveModal,
        VLoader,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_event_show {

    &__list {
        width: 100%;
        margin-top: 1.5rem;
        border-collapse: separate;
        border-spacing: 0 0.5rem;
    }
    &__item {
        &-label {
            white-space: nowrap;
        }
        &-value {
            font-weight: 800;
            color: $c-third;
            text-align: right;
        }
    }
    &__status {
        color: $c-primary;
    }
    &__patient {
        color: $c-third;
    }
    &__heading {
        width: 100%;
        position: relative;
        margin-bottom: 1.5rem;

        &-title {
            width: 100%;

            span {
                display: block;
                margin-right: 0.5rem;
                line-height: 2.6rem;
            }
            a {
                display: inline-block;
                max-width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        &-actions {
            position: absolute;
            top: 0;
            right: 0;

            span {
                margin-left: 0.3rem;
            }
        }
    }
}

</style>
